import { createListenerMiddleware, createSlice, TypedStartListening } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from 'store/store';

import { PREVIOUSLY_VIEWED_POSTS_KEY } from 'constants/general';

import { addPost } from './actions';
import { initialState } from './state';

export const previouslyViewedPostsSlice = createSlice({
  name: 'previouslyViewedPosts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(addPost, (state, { payload }) => {
      const newState = [payload, ...state.filter(postId => postId !== payload)];
      if (newState.length > 3) return newState.slice(0, 3);
      return newState;
    });
  },
});

export const previouslyViewedPostsMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;

const startAppListening = previouslyViewedPostsMiddleware.startListening as AppStartListening;

startAppListening({
  actionCreator: addPost,
  effect: (_, listenerApi) => {
    const postIds = listenerApi.getState().previouslyViewedPosts;

    localStorage.setItem(PREVIOUSLY_VIEWED_POSTS_KEY, JSON.stringify(postIds));
  },
});
